const searchDrawer = () => {
  // Search button
  const searchBtn = document.querySelector('#search button');
  // Search box
  const searchBox = document.querySelector('.search-box');
  // Search field
  const searchFields = document.querySelectorAll('.search-field');
  // Search form
  const searchForm = document.querySelector('.search-box form');
  // Search results
  const searchResults = document.querySelector('.search-results');

  // Open drawer
  searchBtn.addEventListener('click', () => {
    const field = document.querySelector('.search-field');
    field.focus();
    searchBox.classList.add('drawer-opened');
    if (searchResults.style.display === 'block') {
      document.querySelector('body').classList.add('no-scroll');
    }
  });

  // close search button
  const closeSearch = document.querySelector('.close-btn');
  if (closeSearch) {
    closeSearch.addEventListener('click', () => {
      searchBox.classList.remove('drawer-opened');
      document.querySelector('body').classList.remove('no-scroll');
      document.querySelector('html').classList.remove('no-scroll');
    });
  }

  const disableScrolling = () => {
    if (window.innerWidth < 768) {
      const field = document.querySelector('.search-field');
      document.querySelector('body').classList.add('no-scroll');
      field.addEventListener('focusout', (e) => {
        document.querySelector('body').classList.add('no-scroll');
      });
      field.addEventListener('focusin', (e) => {
        document.querySelector('body').classList.add('no-scroll');
      });
      field.addEventListener('focus', (e) => {
        document.querySelector('body').classList.add('no-scroll');
      });
      field.addEventListener('blur', (e) => {
        document.querySelector('body').classList.add('no-scroll');
      });
    }

    document.querySelector('body').addEventListener('touchmove', (e) => {
      e.preventDefault();
    });
  };

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function containsOn(str) {
    return str && str.toLowerCase().includes('-on');
  }

  function filterProductsForOntario(resultsContainer) {
    console.log('Filtering products for Ontario');
    const userLocation = getCookie('location');
    console.log('User location from cookie:', userLocation);
    const isOntario = userLocation === 'Ontario';
    console.log('Is Ontario:', isOntario);
    const productItems = resultsContainer.querySelectorAll('.predictive-search__list-item');
    console.log('Number of product items found:', productItems.length);
    let visibleCount = 0;

    productItems.forEach((item, index) => {
      const link = item.querySelector('a');
      if (!link) {
        console.log(`Item ${index} has no link, skipping`);
        return;
      }

      const href = link.getAttribute('href');
      const sku = link.getAttribute('data-sku') || '';

      console.log(`Item ${index} - URL: ${href}, SKU: ${sku}`);

      const isOnProduct = containsOn(href) || containsOn(sku);
      console.log(`Item ${index} is ON product:`, isOnProduct);

      let shouldDisplay = false;
      if (isOntario) {
        shouldDisplay = isOnProduct;
      } else {
        shouldDisplay = !isOnProduct;
      }

      console.log(`Item ${index} should display:`, shouldDisplay);
      item.style.display = shouldDisplay ? 'block' : 'none';
      if (shouldDisplay) visibleCount++;

      // Adjust URL if necessary
      if (href && (href.includes('/products/') || href.includes('/collections/'))) {
        let newHref = href;
        if (isOntario) {
          if (newHref.includes('-federal')) {
            newHref = newHref.replace('-federal', '-on');
          } else if (!newHref.includes('-on')) {
            newHref += '-on';
          }
        } else {
          newHref = newHref.replace('-on', '');
        }
        if (newHref !== href) {
          console.log(`Item ${index} URL adjusted from ${href} to ${newHref}`);
          link.setAttribute('href', newHref);
        }
      }
    });

    console.log('Visible products count:', visibleCount);
    updateProductCount(visibleCount, resultsContainer);
  }

  function updateProductCount(visibleCount, resultsContainer) {
    console.log('Updating product count');
    const countElement = resultsContainer.querySelector('[data-predictive-search-live-region-count-value]');
    if (countElement) {
      const terms = document.querySelector('.search-field').value;
      const newText = `${visibleCount} results found for "${terms}"`;
      console.log('New count text:', newText);
      countElement.textContent = newText;
    } else {
      console.log('Count element not found');
    }
  }

  searchFields.forEach((searchField) => {
    searchField.addEventListener('keyup', () => {
      const moreResults = document.createElement('input');
      let value = searchField.value;
      if (value.length >= 2) {
        let requestResponse;
        fetch(
          `/search/suggest?q=${value}&resources[type]=product,collection&resources[options][unavailable_products]=show&resources[options][fields]=title,tag,product_type&section_id=predictive-search`
        )
          .then((response) => {
            requestResponse = response;
            return response.text();
          })
          .then((text) => {
            if (!requestResponse.ok) {
              throw new Error(`${requestResponse.status}: ${text}`);
            }
            const resultsMarkup = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-predictive-search').innerHTML;
            const searchResults = searchField.parentElement.parentElement.querySelector('.search-results');
            searchResults.style.display = 'block';
            searchResults.innerHTML = resultsMarkup;

            // Apply Ontario filtering
            setTimeout(() => {
              filterProductsForOntario(searchResults);
            }, 100);
          })
          .then(disableScrolling())
          .then(searchForm.classList.add('opened-drawer-form'))
          .catch((error) => {
            console.error(error);
          });
      } else {
        searchField.parentElement.parentElement.querySelector(
          '.search-results'
        ).style.display = 'none';
        document.querySelector('body').classList.remove('no-scroll');
        searchForm.classList.remove('opened-drawer-form');
      }
    });
  });

  // Add a debug trigger
  window.triggerFilter = function() {
    console.log('Manual filter trigger called');
    const searchResults = document.querySelector('.search-results');
    if (searchResults) {
      filterProductsForOntario(searchResults);
    } else {
      console.log('Search results container not found');
    }
  };
};

// Mobile dropdown
const mobileMenu = () => {
  // Hamburger animation
  const hamburger = document.querySelector('#checkbox2');
  const animatedElement = document.querySelector('.lines');
  const backdrop = document.querySelector('#backdrop');
  hamburger.addEventListener('click', () => {
    backdrop.classList.toggle('backdrop-active');
    document.querySelector('body').classList.toggle('no-scroll');
  });
  // Submenus
  const submenu = document.querySelectorAll('.parent');
  submenu.forEach((menu) => {
    menu.addEventListener('click', (e) => {
      e.preventDefault();
      menu.nextElementSibling.classList.toggle('expand-submenu');
      menu.classList.toggle('active-parent');
      menu.querySelector('button span').classList.toggle('parent-chevron');
    });
  });
};

/**
 * Expand desktop menu
 * List collections + 2 additional links
 */
const menuDesktop = () => {
  const navLinks = document.querySelectorAll('.has-children');
  const backdrop = document.querySelector('.desktop-megamenu-backdrop');

  backdrop.addEventListener('click', () => {
    document.querySelector('.menu-expanded').classList.remove('menu-expanded')
    backdrop.classList.remove('active');
  })

  navLinks.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const elToExpand = el.nextElementSibling;
      if (backdrop) {
        backdrop.classList.add('active');
      }
      if (elToExpand) {
        if (!elToExpand.classList.contains('menu-expanded')) {
          elToExpand.classList.add('menu-expanded');
        } else {
          elToExpand.classList.remove('menu-expanded');
            backdrop.classList.remove('active');
        }
      }
      const expandableLinks = document.querySelectorAll('.expand-menu');
      expandableLinks.forEach((el) => {
        if (e.currentTarget !== el.previousElementSibling) {
          el.classList.remove('menu-expanded');
        }
      });
    });
  });
};

if (window.innerWidth > 768) {
  menuDesktop();
}

searchDrawer();
mobileMenu();

document.addEventListener('shopify:section:load', (e) => {
  if (e.detail.sectionId) {
    searchDrawer();
    mobileMenu();
    menuDesktop();
  }
});

console.log('Script fully loaded and executed');